











































import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {maxBy} from "lodash";
import ErrorFetchingData from "@/components/lfs/NewStatistics/GeneralDashboard/common/ErrorFetchingData.vue";
import {colorsChartChrome} from "@/helpers/colorsChart";
import Highcharts from "highcharts";
import {locales} from "@/helpers/locales";
import {log} from "util";

@Component({
  name: 'CollectTotalSchedule',
  components: {ErrorFetchingData}
})

export default class CollectTotalSchedule extends Vue {
  @Prop({
    type: Object, default: () => {
    }
  }) protected total!: any
  @Prop({type: Array, default: () => []}) protected totalChart!: object[]
  @Prop({type: Boolean, default: false}) protected loading!: boolean
  @Prop({type: Boolean, default: false}) protected error!: boolean

  @Watch('loading')
  updateData(value: any) {
    if (value) return
    setTimeout(() => {
      this.updateSeries()
    }, 0)
  }

  @Watch('$i18n.locale', {immediate: true})
  onLocaleChanged(_: any) {
    setTimeout(() => {
      this.updateSeries()
    }, 0)
  }


  get maxYAxisValue() {
    if (!this.totalChart.length) return 0
    const maxItem: any = maxBy(this.totalChart, (item: any) => item[1])
    return maxItem[1]
  }

  protected updateSeries(): void {

    if (!this.total.sumContacts) return
    const chart: any = this.$refs.totalChart
    chart.chart.update({
      series: [
        {
          showInLegend: true,
          enableMouseTracking: true,
          type: 'pie',
          data: [
            {
              colorHover: '#4E69CB',
              color: '#C4C4C4',
              name: this.$t('newstatistics.v4.general.contacts_collected.pie_1'),
              y: this.total.sumCustomContact
            },
            {
              colorHover: '#D17D63',
              color: '#ababab',
              name: this.$t('newstatistics.v4.general.contacts_collected.pie_2'),
              y: this.total.scansBadges
            },
            {
              colorHover: '#7CB9B9',
              color: '#d9d9d9',
              name: this.$t('newstatistics.v4.general.contacts_collected.pie_3'),
              y: this.total.scansBusinessCard
            },
          ]
        },
      ],

      yAxis: {
        gridLineWidth: 0,
        startOnTick: false,
        endOnTick: false,
        min: 0,
        max: this.maxYAxisValue
      },
    })
  }

  protected setChartWidth() {
    const chartContainer: any = this.$refs.totalChartContainer
    const chart: any = this.$refs.totalChart
    chart.chart.setSize(chartContainer.offsetWidth)
  }


  chartItems: any[] = this.totalChart
  chartOptions = {
    chart: {
      height: '120',
      width: '300',
      backgroundColor: 'transparent',
      margin: 0,
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0
    },
    colors: colorsChartChrome,
    loading: {
      hideDuration: 1000,
      showDuration: 1000
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    xAxis: {
      gridLineWidth: 0,

    },
    yAxis: {
      gridLineWidth: 0,
    },
    tooltip: {
      enabled: true,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      style: {
        zIndex: 500,
        padding: 0
      },
      formatter: function (): any {
        const context: any = this
        return '<div class="statistics-v4-tooltip">' + '<span class="statistics-v4-tooltip-subtitle">'
          + context.key + ': ' + context.y + '</span></div>'
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: false,
        color: '#8EC6E7',
        fillColor: '#8EC6E7',
        size: '100%',
        dataLabels: {enabled: false}
      },
    },
    series: [{
      states: {
        hover: {
          enabled: true
        }
      },
      point: {
        events: {
          mouseOver: function ()  {
            const context:any = this
            context.graphic.attr("fill", context.colorHover);
          },
          mouseOut: function () {
            const context:any = this
            context.graphic.attr("fill", context.color);
          }
        }
      },
      showInLegend: true,
      enableMouseTracking: true,
      type: 'pie',
      data: [
        {
          color: '#C4C4C4',
          name: this.$t('newstatistics.v4.general.contacts_collected.pie_1'),
          y: this.total.sumCustomContact
        },
        {
          color: '#ababab',
          name: this.$t('newstatistics.v4.general.contacts_collected.pie_2'),
          y: this.total.scansBadges
        },
        {
          color: '#d9d9d9',
          name: this.$t('newstatistics.v4.general.contacts_collected.pie_3'),
          y: this.total.scansBusinessCard
        },
      ]
    },

    ]
  }
}
